export class Brand {

  public brandID: number;
  public brandName: string;
  public brandLogoImage: string;
  public brandCount: number;
  public isChecked: boolean = false;
}



// WEBPACK FOOTER //
// ./src/app/models/brand/brand-model.ts